"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateWithOffset = void 0;
const getDateWithOffset = (targetDate, serverUtcOffset, customDate) => {
    const date = customDate ? new Date(customDate) : new Date();
    const localOffset = date.getTimezoneOffset();
    const totalOffset = serverUtcOffset - localOffset;
    return new Date(targetDate.getTime() + totalOffset * 60 * 1000);
};
exports.getDateWithOffset = getDateWithOffset;
//# sourceMappingURL=getDateWithOffset.js.map